export * from './combo-input/combo-input.module';
export * from './alert/angular-alert.module';
export * from './confirm/angular-confirm.module';
export * from './breadcrumb/angular-breadcrumb.module';
export * from './codice-fiscale/codice-fiscale.module';
export * from './login/angular-login.module';
export * from './mail-composer/angular-mail-composer.module';
export * from './menu/angular-menu.module';
export * from './table/angular-table.module';
export * from './progress-steps/angular-progress-steps.module';
export * from './datepicker/angular-datepicker.module';
export * from './combo/angular-combo.module';
export * from './modal/angular-modal.module';
export * from './file-upload/file-upload.module';
export * from './input-number/input-number.module';
export * from './google-place-autocomplete/google-place-autocomplete.module';
export * from './embedded-video/embedded-video.module';
export * from './treeview/treeview.module';
export * from './checkbox/checkbox.module';

export * from './combo-input/combo-input.component';
export * from './alert/angular-alert.component';
export * from './confirm/angular-confirm.component';
export * from './breadcrumb/angular-breadcrumb.component';
export * from './codice-fiscale/codice-fiscale.component';
export * from './login/angular-login.component';
export * from './mail-composer/angular-mail-composer.component';
export * from './menu/angular-menu.component';
export * from './table/angular-table.component';
export * from './progress-steps/angular-progress-steps.component';
export * from './datepicker/angular-datepicker.component';
export * from './combo/angular-combo.component';
export * from './modal/angular-modal.component';
export * from './file-upload/file-upload.component';
export * from './input-number/input-number.component';
export * from './google-place-autocomplete/google-place-autocomplete.component';
export * from './embedded-video/embedded-video.component';
export * from './treeview/treeview.component';
export * from './checkbox/checkbox.component';



// WEBPACK FOOTER //
// ./src/angular_library/components/index.ts